import { ScanQrTicketSelectItemPage } from "./scan-qr-ticket-select-item/scan-qr-ticket-select-item.page";
import { ScanQrTicketItemPage } from "./scan-qr-ticket-item/scan-qr-ticket-item.page";

export const PAGES = [
  ScanQrTicketSelectItemPage,
  ScanQrTicketItemPage
];
